import React, { useEffect, useState } from "react";

const NftsMintedData = ({ nfts, wallet }) => {
  console.log(nfts[0].edition);

  const [revealed, setRevealed] = useState(true);

  useEffect(() => {
    if (nfts[0]?.name === "Unrevealed Mr. Crypto") setRevealed(false);
    console.log("isrevealed minted-data", revealed);
  }, []);

  return (
    <div className="d-flex flex-wrap w-100 justify-content-center">
      {nfts?.map((nft) => (
        <div className="nftCard__container mt-5" key={nft?.date}>
          <img src={nft.image} />
          <p className="pt-3">{nft?.name}</p>
          <div className="row text-center pt-1">
            {nft.attributes &&
              nft?.attributes.map((atb) => (
                <div className="col-6 ">
                  <div>{atb?.trait_type}</div>
                  <p className="attribute">{atb?.value}</p>
                </div>
              ))}
          </div>
          <a
            className="txn-link"
            target="_blank"
            href={
              revealed
                ? ` 
                https://opensea.io/assets/matic/0xef453154766505feb9dbf0a58e6990fd6eb66969/${nft.edition}
                
              `
                : `https://opensea.io/${wallet} `
            }
          >
            Ver en Opensea
          </a>
        </div>
      ))}
    </div>
  );
};

export default NftsMintedData;
